(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/theme-helpers/assets/javascripts/format-odds.js') >= 0) return;  svs.modules.push('/components/themes/theme-helpers/assets/javascripts/format-odds.js'); "use strict";

(function (svs) {
  var formatOdds = function formatOdds(value) {
    if (typeof value === 'string') {
      value = svs.utils.format.CurrencyFromJupiterString(value);
    }

    if (typeof value === 'number') {
      value = Math.round(value);
    }

    return value;
  };

  svs.themes.formatOdds = formatOdds;
})(svs);
 })(window);